import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';
import { Subscription } from "rxjs";

import { InformationComponent } from '../../core/information/information.component';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CALENDAR_LOCALE, CeleryStatus } from "../../services/constant";
import { TemplateService } from '../../services/template.service';
import { DownloadLogComponent } from '../download-log/download-log.component';

@Component({
  selector: 'app-tax-report',
  templateUrl: './submit-to-rd.component.html',
  styleUrls: ['./submit-to-rd.scss'],
  providers: [TemplateService]
})
export class SubmitToRdComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  calendarLocale;
  selectedCompany: SelectItem[];
  company: any;
  canDownloadZipOption: any;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allBranch = true;
  allDocType = true;
  notSubmittedCompletely: any;
  branch: any;
  documentType: any;
  selectedValues = [];
  test: any;
  tableData: any;
  tableDataDisplay: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  loading_all_excel = false;
  loading_all_excel_message = '';
  no_data = true;
  value = 0;
  sum_docs_count = 0;
  errorMsg = '';
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];

  selectedMonth: any;
  selectedYear: any;

  allExcelCount: number;
  allExcelCurrent = 0;

  index = 0;
  modalData: any;

  branchList: any = null;
  selectedBranch: SelectItem[];
  allBranchList: any = null;

  loading_excel_report = false;

  sortBy: string;
  sortMode: string;
  is_TH = false;

  rdDocumentType: any;
  selectedRdDocumentType: any;

  tableCol = [];

  listOfTaxIdLists: {};
  sendToRdMessage = '';
  subs: Subscription;

  percentage = 8;
  sendingTaskInterval;
  submitResult: string;
  submitting = false;

  @ViewChild("submitToRDContent") submitToRDContent: ElementRef;
  @ViewChild('tt') table: any;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.cancelSendingTask();
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.populateDropdown();
    });
    this.populateDropdown();
    this.searchData();
  }

  cancelSendingTask() {
    if (this.sendingTaskInterval) {
      clearInterval(this.sendingTaskInterval);
    }
  }

  subscribeSendingTaskStatus(taskId: string): void {
    this.sendingTaskInterval = undefined;
    this.sendingTaskInterval = setInterval(() => {
      this.apiService.getCeleryTasks({task_id: taskId}).subscribe({
        next: (result) => {
          const percentageValue = _.get(result, "percentage", 0);
          this.percentage = _.max([percentageValue, this.percentage])
          if (
            [CeleryStatus.Failure, CeleryStatus.Success].includes(result._state)
          ) {
            this.percentage = 100;
            clearInterval(this.sendingTaskInterval);
            if (result._state === CeleryStatus.Success) {
              this.submitResult = this.translate.instant('SUBMIT-TO-RD.SUBMIT-SUCCESS');
            } else {
              this.submitResult = result.detail;
            }
            this.submitting = false;
          }
        },
        error: (err) => {
          this.submitting = false;
          this.submitResult = this.translate.instant('SUBMIT-TO-RD.SUBMIT-ERROR');
          clearInterval(this.sendingTaskInterval);
        },
      });
    }, 3000);
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  populateDropdown() {
    this.calendarLocale = this.currentLang === 'en'
      ? CALENDAR_LOCALE.EN
      : CALENDAR_LOCALE.TH
    this.loadCompanyAndBranch();
    this.loadDocumentType();
    this.loadTableHeader();
  }

  loadDocumentType() {
    const documentData = this.template.getDropdown();
    documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
    this.rdDocumentType = documentData.filter(obj => obj.value !== 'receipt');
    this.selectedRdDocumentType = null;
  }

  loadTableHeader() {
    this.tableCol = [
      {field: 'issue_date', header: this.translate.instant('TABLE.ISSUE-DATE')},
      {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
      {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
      {field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS')},
      {field: 'verified_by_acc', header: this.translate.instant('SUBMIT-TO-RD.VERIFIED-BY-ACCOUNT')},
      {field: 'sent_to_rd', header: this.translate.instant('SUBMIT-TO-RD.SENT-TO-RD')},
      {field: 'submit_completely', header: this.translate.instant('SUBMIT-TO-RD.SUBMIT-COMPLETELY')},
    ];
  }

  loadCompanyAndBranch() {
    this.company = [];
    this.apiService.getCompany().subscribe(
      (result) => {
        this.company = [{
          label: this.translate.instant('COMMON.ALL'),
          value: null
        }]
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.selectedCompany = null;
      }
    );
    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  canUserDownloadDoc() {
    return true;
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate == this.selectedCompany)
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
    });
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    const data = {
      not_submitted_completely: this.notSubmittedCompletely ? this.notSubmittedCompletely : null,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD'),
      company_id: this.selectedCompany ? this.selectedCompany : null,
      branch_id: this.selectedBranch ? this.selectedBranch : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.apiService.postSubmitToRd(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.tableDataDisplay = this.tableData;
        this.sum_docs_count = result.sum_docs_count;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;

        this.selectedValues = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.selectedValues.push(false);
        }

        this.listOfTaxIdLists = result.results.map(function (item) {
          return item['approved_but_not_in_ebxml_taxdataid_list'].concat(item['distinct_replaced_tax_data_id_list']);
        });

      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  confirm() {
    if (this.modalData.uploaded === false) {
      const params = {
        approved: true,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    } else {
      const params = {
        approved: false,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    }
  }

  revertBack() {
    this.searchData();
    this.modal.close();
  }

  clearData() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.selectedCompany = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.notSubmittedCompletely = false;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;

    this.searchButtonClicked();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' '
        + this.translate.instant('COMMON.CORRECT');
    }
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = this.tableData[i].total_documents === this.tableData[i].total_approved_docs && !this.tableData[i].submit_completely;
    }
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = false;
    }
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }


  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      not_submitted_completely: this.notSubmittedCompletely ? this.notSubmittedCompletely : null,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD'),
      company_id: this.selectedCompany ? this.selectedCompany : null,
      branch_id: this.selectedBranch ? this.selectedBranch : null,
      rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
    };

    this.apiService.exportExcelSubmitToRd(params).subscribe(
      () => {
        this.loading_excel_report = false;
        this.informUser(
          this.translate.instant('COMMON.ADDED-TO-QUEUE')
        );
      },
      (error) => {
        this.loading_excel_report = false;
        this.informUser();
      }
    );
  }

  informUser(message?: string) {
    const modal = this.modalService.open(InformationComponent, { centered: true });
    modal.componentInstance.message = message || this.translate.instant('ERROR.TRY-AGAIN');
  }

  showDownloadLogs() {
    const modal = this.modalService.open(DownloadLogComponent, { size: 'lg' });
    modal.componentInstance.feature = 'submit_to_rd';
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  submitCheckedToRd(content) {
    const taxDataIdSet = new Set();

    // get only indexes that have been selected
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        for (let j = 0; j < this.listOfTaxIdLists[i].length; j++) {
          taxDataIdSet.add(this.listOfTaxIdLists[i][j]);
        }
      }
    }

    const taxDataIdArray = Array.from(taxDataIdSet.values());

    if (taxDataIdArray.length === 0) {
      this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.NO-DATA');
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
    } else {
      this.submitting = true;
      const params = {
        taxDataIdArray: taxDataIdArray
      };
      this.apiService.submitCheckedToRd(params).subscribe(
        (result) => {
          this.modal = this.modalService.open(this.submitToRDContent, {
            backdrop: "static",
            centered: true,
            keyboard: false,
          });
          this.subscribeSendingTaskStatus(result.task_id);
        },
        (error) => {
          this.submitting = false;
        }
      );
    }
  }

  closeDownloadAll() {
    this.modal.close();
    this.loading_all_excel = false;
    this.allExcelCurrent = 0;
    this.percentage = 8;
    this.submitResult = undefined;
    this.submitting = false;
    this.searchButtonClicked();
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'SUBMIT_RD',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.component.ts